module.exports = __webpack_public_path__ + "img/repas.dd991b6a.jpg";